import script from "./MarqueeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MarqueeBanner.vue?vue&type=script&setup=true&lang=js"

import "./MarqueeBanner.vue?vue&type=style&index=0&id=9cc1609e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc1609e"]])

export default __exports__